export const pxToRem = (px: number, baseFontSize: number = 16): string => {
  const remValue = px / baseFontSize;
  return `${remValue}rem`;
};
